import React from "react";
import PropTypes from "prop-types";
import { Menu } from "./styles.js";

export const HamburgerButton = ({ showNavBar, toggleHamburgerIcon }) => {
  const toggleIcon = () => {
    return showNavBar ? (
      <img src="/images/close.svg" />
    ) : (
      <img src="/images/hamburger-menu-icon.svg" />
    );
  };

  return <Menu onClick={toggleHamburgerIcon}>{toggleIcon()}</Menu>;
};

HamburgerButton.propTypes = {
  showNavBar: PropTypes.bool.isRequired,
  toggleHamburgerIcon: PropTypes.func.isRequired,
};

export default HamburgerButton;
